import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import Details from '../components/details';
import { fetchNotificationInfo, fetchCallInfo } from './notification_call-actions';

const mapStateToProps = (state) => {
  const activeServiceCenter = state.navigation.navigationSelf.serviceCenterId;
  return {
    data: state.notification_call.data,
    partners: state.notification_call.partners,
    partnerTypes: state.referenceData.data[`${activeServiceCenter}_order_partnerTypes`],
    notes: state.notification_call.notes,
    parentInfo: state.notification_call.parentInfo,
    taskList: state.notification_call.taskList,
    partList: state.notification_call.partList,
    isLoading: state.notification_call.isLoading,
    actions: state.notification_call.actions,
    error: state.notification_call.error,
  };
};

const mapDispatchToProps = {
  fetchNotification: fetchNotificationInfo,
  fetchCall: fetchCallInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Details));
